import type { FcmDetails, FcmDetailsMap } from './types';

function createFcmDetails<N extends string>(name: N, details: FcmDetails): FcmDetailsMap<N> {
	return { [name]: details } as FcmDetailsMap<N>;
}

export { createFcmDetails };
